export enum ProductVariantType {
	Weight = "Weight",
	Size = "Size",
	None = "None",
}
